/* Taptics · generador del texto del QR WiFi (formato WIFI: de ZXing).
   Es la referencia única: la ficha de Shopify, el panel y el archivo de grabado
   deben producir exactamente la misma cadena con esta lógica. */
(function (root) {
  var TYPES = { WPA: 'WPA', WEP: 'WEP', NONE: 'nopass' };

  // \ ; , : " se escapan anteponiendo una barra invertida (en un solo paso).
  var SPECIAL = /[\\;,:"]/g;
  function esc(s) { return String(s).replace(SPECIAL, function (c) { return '\\' + c; }); }

  function utf8Len(s) { return new TextEncoder().encode(s).length; }
  var isHex = function (s) { return /^[0-9a-fA-F]+$/.test(s); };
  var isPrintableAscii = function (s) { return /^[\x20-\x7E]*$/.test(s); };

  /* data = { ssid, password, security: 'WPA'|'WEP'|'NONE', hidden: bool }
     Devuelve { ok, errors[], warnings[], payload } */
  function build(data) {
    var errors = [], warnings = [];
    var ssid = data.ssid == null ? '' : String(data.ssid);
    var pw = data.password == null ? '' : String(data.password);
    var sec = data.security || 'WPA';

    if (!TYPES[sec]) errors.push('security');
    if (!ssid.length) errors.push('ssid_empty');
    else if (utf8Len(ssid) > 32) errors.push('ssid_too_long');
    if (/^\s|\s$/.test(ssid)) warnings.push('ssid_edge_spaces');
    if (/[\u0000-\u001F\u007F]/.test(ssid + pw)) errors.push('control_chars');
    // Caracteres invisibles que llegan al copiar y pegar (espacio duro, ancho cero, BOM)
    if (/[ ​-‍⁠﻿]/.test(ssid + pw)) errors.push('invisible_chars');
    // El teclado del iPhone cambia ' " - ... por ’ “ — … (puntuación inteligente)
    if (/[‘’‚“”„–—…]/.test(ssid + pw)) warnings.push('smart_punct');

    if (sec === 'WPA') {
      if (pw.length === 64) { if (!isHex(pw)) errors.push('wpa_64_not_hex'); }
      else if (pw.length < 8 || pw.length > 63) errors.push('wpa_length');
      // No repetir aviso si lo único raro es la puntuación del iPhone
      if (!isPrintableAscii(pw.replace(/[\u2018\u2019\u201A\u201C\u201D\u201E\u2013\u2014\u2026\u00A0\u200B-\u200D\u2060\uFEFF]/g, ''))) warnings.push('pw_non_ascii');
    } else if (sec === 'WEP') {
      var L = pw.length;
      var okWep = ((L === 5 || L === 13) && isPrintableAscii(pw)) || ((L === 10 || L === 26) && isHex(pw));
      if (!okWep) errors.push('wep_length');
    } else if (sec === 'NONE') {
      if (pw.length) warnings.push('pw_ignored_open');
      pw = '';
    }
    if (/^\s|\s$/.test(pw)) warnings.push('pw_edge_spaces');

    var p = 'WIFI:T:' + TYPES[sec] + ';S:' + esc(ssid) + ';';
    if (sec !== 'NONE') p += 'P:' + esc(pw) + ';';
    if (data.hidden) p += 'H:true;';
    p += ';';
    return { ok: errors.length === 0, errors: errors, warnings: warnings, payload: errors.length ? null : p };
  }

  // Lector inverso (para pruebas y para comprobar un QR ya generado).
  function parse(payload) {
    if (payload.indexOf('WIFI:') !== 0) return null;
    var out = {}, body = payload.slice(5), key = '', val = '', inKey = true;
    for (var i = 0; i < body.length; i++) {
      var c = body[i];
      if (inKey) { if (c === ':') inKey = false; else if (c === ';') { break; } else key += c; continue; }
      if (c === '\\' && i + 1 < body.length) { val += body[++i]; continue; }
      if (c === ';') { out[key] = val; key = ''; val = ''; inKey = true; continue; }
      val += c;
    }
    return out;
  }

  var api = { build: build, parse: parse, escape: esc };
  if (typeof module !== 'undefined' && module.exports) module.exports = api; else root.TapticsWifiQR = api;
})(this);
/* Taptics · formulario de la placa WiFi en la ficha de producto.
   Necesita TapticsWifiQR (wifi-qr.js) y qrcode-generator (qrcode). */
(function () {
  if (!window.TapticsWifiQR) return;
  var W = window.TapticsWifiQR;

  var T = {
    es: {
      reads: 'El QR contiene la red', e_invisible_chars: 'Hay un espacio o carácter invisible copiado de otro sitio. Escribe los datos a mano.',
      w_smart_punct: 'Has escrito ’ “ ” o — (el teclado del iPhone los pone solo). Tu router casi seguro usa \' " o -. Revísalo: si no coincide, no conectará.',
      title: 'Datos de tu WiFi', intro: 'Los grabamos en el QR de tu placa. Escríbelos exactamente como son.',
      ssid: 'Nombre de la red WiFi', ssidHelp: 'Tal cual aparece en el móvil, con mayúsculas, espacios y símbolos.',
      sec: 'Tipo de seguridad', secWPA: 'WPA / WPA2 / WPA3 (la más habitual)', secWEP: 'WEP (routers muy antiguos)', secNONE: 'Red abierta, sin contraseña',
      secHelp: 'Si no lo sabes, deja la primera: es la de casi todos los routers. Viene en la pegatina del router.',
      pw: 'Contraseña del WiFi', pwHelp: 'Ojo con mayúsculas, ceros y oes. El móvil a veces pone la primera letra en mayúscula sola.',
      hidden: 'Mi red está oculta (no aparece en la lista de redes del móvil)',
      plate: 'Texto de la placa', showCreds: 'Grabar también el nombre de la red y la contraseña (por si algún móvil no lee el QR)',
      lang_es: 'Español: «Escanea para conectarte»', lang_fr: 'Francés: «Scannez pour vous connecter»', lang_en: 'Inglés: «Scan to connect»', lang_de: 'Alemán: «Zum Verbinden scannen»',
      preview: 'Compruébalo antes de comprar', previewHelp: 'Escanea este QR con la cámara de tu móvil estando en tu local. Si te conecta, tu placa funcionará igual.',
      previewEmpty: 'El QR aparecerá aquí cuando los datos sean correctos.',
      confirm: 'He comprobado el nombre de la red y la contraseña. Si los cambio, la placa dejará de conectar.',
      enterprise: '¿Tu red pide usuario y contraseña (WPA2/WPA3 Empresa)? No es compatible con un QR: usa una red de invitados.',
      fix: 'Revisa los datos del WiFi antes de añadir al carrito.',
      e_ssid_empty: 'Escribe el nombre de la red.', e_ssid_too_long: 'El nombre de la red es demasiado largo (máximo 32 caracteres; las letras con tilde y los emojis cuentan doble).',
      e_wpa_length: 'La contraseña WPA debe tener entre 8 y 63 caracteres.', e_wpa_64_not_hex: 'Una contraseña de 64 caracteres solo puede llevar 0-9 y A-F.',
      e_wep_length: 'Una contraseña WEP tiene 5 o 13 caracteres (o 10 o 26 en hexadecimal).', e_control_chars: 'Hay un carácter invisible no válido. Vuelve a escribir los datos.',
      e_confirm: 'Marca la casilla de comprobación.',
      w_ssid_edge_spaces: 'El nombre de la red empieza o acaba con un espacio. ¿Seguro que es así?', w_pw_edge_spaces: 'La contraseña empieza o acaba con un espacio. ¿Seguro que es así?',
      w_pw_non_ascii: 'La contraseña lleva ñ, tildes u otros símbolos especiales. Muchos routers no los admiten: compruébala escaneando el QR.',
      p_ssid: 'Red WiFi', p_pw: 'Contraseña', p_sec: 'Seguridad', p_hidden: 'Red oculta', p_plate: 'Texto de la placa', yes: 'Sí',
      creds: 'con nombre y contraseña', nocreds: 'solo el QR', open: 'Abierta (sin contraseña)'
    },
    fr: {
      reads: 'Le QR code contient le réseau', e_invisible_chars: 'Il y a un espace ou un caractère invisible copié d’ailleurs. Saisissez les informations à la main.',
      w_smart_punct: 'Vous avez saisi ’ “ ” ou — (le clavier de l’iPhone les met tout seul). Votre box utilise presque sûrement \' " ou -. Vérifiez : sinon, la connexion échouera.',
      title: 'Votre WiFi', intro: 'Nous les gravons dans le QR code de votre plaque. Saisissez-les exactement.',
      ssid: 'Nom du réseau WiFi', ssidHelp: 'Tel qu’il apparaît sur le téléphone, avec majuscules, espaces et symboles.',
      sec: 'Type de sécurité', secWPA: 'WPA / WPA2 / WPA3 (le plus courant)', secWEP: 'WEP (box très anciennes)', secNONE: 'Réseau ouvert, sans mot de passe',
      secHelp: 'Si vous ne savez pas, laissez le premier : c’est celui de presque toutes les box. Il figure sur l’étiquette de la box.',
      pw: 'Mot de passe WiFi', pwHelp: 'Attention aux majuscules, aux zéros et aux O. Le téléphone met parfois la première lettre en majuscule tout seul.',
      hidden: 'Mon réseau est masqué (il n’apparaît pas dans la liste des réseaux)',
      plate: 'Texte de la plaque', showCreds: 'Graver aussi le nom du réseau et le mot de passe (si un téléphone ne lit pas le QR code)',
      lang_es: 'Espagnol : « Escanea para conectarte »', lang_fr: 'Français : « Scannez pour vous connecter »', lang_en: 'Anglais : « Scan to connect »', lang_de: 'Allemand : « Zum Verbinden scannen »',
      preview: 'Vérifiez avant d’acheter', previewHelp: 'Scannez ce QR code avec l’appareil photo de votre téléphone dans votre établissement. S’il se connecte, votre plaque fonctionnera aussi.',
      previewEmpty: 'Le QR code apparaîtra ici quand les informations seront correctes.',
      confirm: 'J’ai vérifié le nom du réseau et le mot de passe. Si je les change, la plaque ne se connectera plus.',
      enterprise: 'Votre réseau demande un identifiant et un mot de passe (WPA2/WPA3 Entreprise) ? Ce n’est pas compatible avec un QR code : utilisez un réseau invité.',
      fix: 'Vérifiez les informations WiFi avant d’ajouter au panier.',
      e_ssid_empty: 'Saisissez le nom du réseau.', e_ssid_too_long: 'Le nom du réseau est trop long (32 caractères maximum ; les lettres accentuées et les emojis comptent double).',
      e_wpa_length: 'Le mot de passe WPA doit contenir entre 8 et 63 caractères.', e_wpa_64_not_hex: 'Un mot de passe de 64 caractères ne peut contenir que 0-9 et A-F.',
      e_wep_length: 'Un mot de passe WEP contient 5 ou 13 caractères (ou 10 ou 26 en hexadécimal).', e_control_chars: 'Un caractère invisible n’est pas valide. Saisissez à nouveau les informations.',
      e_confirm: 'Cochez la case de vérification.',
      w_ssid_edge_spaces: 'Le nom du réseau commence ou finit par un espace. Êtes-vous sûr ?', w_pw_edge_spaces: 'Le mot de passe commence ou finit par un espace. Êtes-vous sûr ?',
      w_pw_non_ascii: 'Le mot de passe contient des accents ou des symboles spéciaux. Beaucoup de box ne les acceptent pas : vérifiez en scannant le QR code.',
      p_ssid: 'Réseau WiFi', p_pw: 'Mot de passe', p_sec: 'Sécurité', p_hidden: 'Réseau masqué', p_plate: 'Texte de la plaque', yes: 'Oui',
      creds: 'avec nom et mot de passe', nocreds: 'QR code seul', open: 'Ouvert (sans mot de passe)'
    },
    en: {
      reads: 'The QR code holds the network', e_invisible_chars: 'There is an invisible space or character pasted from elsewhere. Please type the details by hand.',
      w_smart_punct: 'You typed ’ “ ” or — (the iPhone keyboard adds them on its own). Your router almost certainly uses \' " or -. Check it: if it doesn’t match, it won’t connect.',
      title: 'Your WiFi details', intro: 'We engrave them into your stand’s QR code. Type them exactly as they are.',
      ssid: 'WiFi network name', ssidHelp: 'Exactly as it appears on your phone, with capitals, spaces and symbols.',
      sec: 'Security type', secWPA: 'WPA / WPA2 / WPA3 (most common)', secWEP: 'WEP (very old routers)', secNONE: 'Open network, no password',
      secHelp: 'If you’re not sure, keep the first one: almost every router uses it. It’s on the router’s label.',
      pw: 'WiFi password', pwHelp: 'Watch out for capitals, zeros and O’s. Phones sometimes capitalise the first letter on their own.',
      hidden: 'My network is hidden (it doesn’t show in the phone’s network list)',
      plate: 'Stand text', showCreds: 'Also engrave the network name and password (in case a phone can’t read the QR code)',
      lang_es: 'Spanish: “Escanea para conectarte”', lang_fr: 'French: “Scannez pour vous connecter”', lang_en: 'English: “Scan to connect”', lang_de: 'German: “Zum Verbinden scannen”',
      preview: 'Check it before you buy', previewHelp: 'Scan this QR code with your phone camera at your venue. If it connects, your stand will work too.',
      previewEmpty: 'The QR code will appear here once the details are valid.',
      confirm: 'I’ve checked the network name and password. If I change them, the stand will stop connecting.',
      enterprise: 'Does your network ask for a username and password (WPA2/WPA3 Enterprise)? That can’t work with a QR code: use a guest network.',
      fix: 'Check your WiFi details before adding to cart.',
      e_ssid_empty: 'Enter the network name.', e_ssid_too_long: 'The network name is too long (32 characters max; accented letters and emojis count double).',
      e_wpa_length: 'A WPA password has 8 to 63 characters.', e_wpa_64_not_hex: 'A 64-character password can only contain 0-9 and A-F.',
      e_wep_length: 'A WEP password has 5 or 13 characters (or 10 or 26 hex).', e_control_chars: 'There’s an invalid invisible character. Please retype the details.',
      e_confirm: 'Tick the confirmation box.',
      w_ssid_edge_spaces: 'The network name starts or ends with a space. Is that right?', w_pw_edge_spaces: 'The password starts or ends with a space. Is that right?',
      w_pw_non_ascii: 'The password has accents or special symbols. Many routers don’t accept them: check it by scanning the QR code.',
      p_ssid: 'WiFi network', p_pw: 'Password', p_sec: 'Security', p_hidden: 'Hidden network', p_plate: 'Stand text', yes: 'Yes',
      creds: 'with name and password', nocreds: 'QR code only', open: 'Open (no password)'
    },
    de: {
      reads: 'Der QR-Code enthält das Netz', e_invisible_chars: 'Ein unsichtbares Leer- oder Sonderzeichen wurde mit eingefügt. Bitte gib die Daten von Hand ein.',
      w_smart_punct: 'Du hast ’ “ ” oder — eingegeben (die iPhone-Tastatur setzt sie automatisch). Dein Router nutzt fast sicher \' " oder -. Prüfe das, sonst klappt die Verbindung nicht.',
      title: 'Deine WLAN-Daten', intro: 'Wir gravieren sie in den QR-Code deines Aufstellers. Gib sie genau so ein, wie sie sind.',
      ssid: 'WLAN-Name', ssidHelp: 'Genau wie auf dem Handy angezeigt, mit Groß-/Kleinschreibung, Leerzeichen und Symbolen.',
      sec: 'Sicherheitstyp', secWPA: 'WPA / WPA2 / WPA3 (am häufigsten)', secWEP: 'WEP (sehr alte Router)', secNONE: 'Offenes Netz, ohne Passwort',
      secHelp: 'Wenn du es nicht weißt, lass die erste Option: Fast alle Router nutzen sie. Sie steht auf dem Router-Aufkleber.',
      pw: 'WLAN-Passwort', pwHelp: 'Achte auf Groß-/Kleinschreibung, Nullen und O. Das Handy schreibt den ersten Buchstaben manchmal von selbst groß.',
      hidden: 'Mein Netz ist versteckt (es erscheint nicht in der Netzliste)',
      plate: 'Text auf dem Aufsteller', showCreds: 'Auch WLAN-Name und Passwort gravieren (falls ein Handy den QR-Code nicht liest)',
      lang_es: 'Spanisch: „Escanea para conectarte“', lang_fr: 'Französisch: „Scannez pour vous connecter“', lang_en: 'Englisch: „Scan to connect“', lang_de: 'Deutsch: „Zum Verbinden scannen“',
      preview: 'Vor dem Kauf prüfen', previewHelp: 'Scanne diesen QR-Code in deinem Lokal mit der Handykamera. Wenn er verbindet, funktioniert auch dein Aufsteller.',
      previewEmpty: 'Der QR-Code erscheint hier, sobald die Daten gültig sind.',
      confirm: 'Ich habe WLAN-Name und Passwort geprüft. Wenn ich sie ändere, verbindet der Aufsteller nicht mehr.',
      enterprise: 'Fragt dein Netz nach Benutzername und Passwort (WPA2/WPA3 Enterprise)? Das geht nicht per QR-Code: nutze ein Gastnetz.',
      fix: 'Prüfe deine WLAN-Daten, bevor du in den Warenkorb legst.',
      e_ssid_empty: 'Gib den WLAN-Namen ein.', e_ssid_too_long: 'Der WLAN-Name ist zu lang (max. 32 Zeichen; Umlaute und Emojis zählen doppelt).',
      e_wpa_length: 'Ein WPA-Passwort hat 8 bis 63 Zeichen.', e_wpa_64_not_hex: 'Ein Passwort mit 64 Zeichen darf nur 0-9 und A-F enthalten.',
      e_wep_length: 'Ein WEP-Passwort hat 5 oder 13 Zeichen (oder 10 bzw. 26 hexadezimal).', e_control_chars: 'Ein unsichtbares Zeichen ist ungültig. Bitte gib die Daten neu ein.',
      e_confirm: 'Setze das Häkchen zur Bestätigung.',
      w_ssid_edge_spaces: 'Der WLAN-Name beginnt oder endet mit einem Leerzeichen. Stimmt das?', w_pw_edge_spaces: 'Das Passwort beginnt oder endet mit einem Leerzeichen. Stimmt das?',
      w_pw_non_ascii: 'Das Passwort enthält Umlaute oder Sonderzeichen. Viele Router akzeptieren sie nicht: prüfe es, indem du den QR-Code scannst.',
      p_ssid: 'WLAN', p_pw: 'Passwort', p_sec: 'Sicherheit', p_hidden: 'Verstecktes Netz', p_plate: 'Text auf dem Aufsteller', yes: 'Ja',
      creds: 'mit Name und Passwort', nocreds: 'nur QR-Code', open: 'Offen (ohne Passwort)'
    }
  };
  var PLATE = { es: 'Escanea para conectarte', fr: 'Scannez pour vous connecter', en: 'Scan to connect', de: 'Zum Verbinden scannen' };

  function el(tag, attrs, text) {
    var e = document.createElement(tag);
    for (var k in attrs || {}) e.setAttribute(k, attrs[k]);
    if (text != null) e.textContent = text;
    return e;
  }
  function field(labelText, input, help) {
    var w = el('div', { 'class': 'tpxw-f' });
    var lb = el('label', { 'for': input.id }, labelText);
    w.appendChild(lb); w.appendChild(input);
    if (help) w.appendChild(el('p', { 'class': 'tpxw-h' }, help));
    return w;
  }
  function check(id, text, checked) {
    var w = el('label', { 'class': 'tpxw-c', 'for': id });
    var c = el('input', { type: 'checkbox', id: id });
    c.checked = !!checked;
    w.appendChild(c); w.appendChild(el('span', null, text));
    return { wrap: w, input: c };
  }

  /* Crea el formulario dentro de root. opts = { lang, idp (prefijo de ids), onChange(ok) }.
     Lo usan la ficha WiFi (abajo) y la página «Elige tus placas» (tpx-placas.js). */
  function create(root, opts) {
    opts = opts || {};
    var L = String(opts.lang || 'es').slice(0, 2);
    var t = T[L] || T.es;
    var P = opts.idp || 'tpxw';
    // Construcción del formulario
    root.appendChild(el('p', { 'class': 'tpxw-t' }, t.title));
    root.appendChild(el('p', { 'class': 'tpxw-h' }, t.intro));

    var noAuto = { autocomplete: 'off', autocapitalize: 'none', autocorrect: 'off', spellcheck: 'false' };
    var ssid = el('input', Object.assign({ type: 'text', id: P + '-ssid', maxlength: '64' }, noAuto));
    root.appendChild(field(t.ssid, ssid, t.ssidHelp));

    var sec = el('select', { id: P + '-sec' });
    [['WPA', t.secWPA], ['WEP', t.secWEP], ['NONE', t.secNONE]].forEach(function (o) { sec.appendChild(el('option', { value: o[0] }, o[1])); });
    var secF = field(t.sec, sec, t.secHelp);
    secF.appendChild(el('p', { 'class': 'tpxw-h' }, t.enterprise));
    root.appendChild(secF);

    var pw = el('input', Object.assign({ type: 'text', id: P + '-pw', maxlength: '64', 'class': 'tpxw-mono' }, noAuto));
    var pwF = field(t.pw, pw, t.pwHelp);
    root.appendChild(pwF);

    var hid = check(P + '-hid', t.hidden, false);
    root.appendChild(hid.wrap);

    var langSel = el('select', { id: P + '-lang' });
    ['es', 'fr', 'en', 'de'].forEach(function (k) { var o = el('option', { value: k }, t['lang_' + k]); if (k === L) o.selected = true; langSel.appendChild(o); });
    root.appendChild(field(t.plate, langSel));
    var creds = check(P + '-creds', t.showCreds, true);
    root.appendChild(creds.wrap);

    var box = el('div', { 'class': 'tpxw-qr' });
    var qrHold = el('div', { 'class': 'tpxw-qri' });
    var qrTxt = el('div');
    qrTxt.appendChild(el('p', { 'class': 'tpxw-t2' }, t.preview));
    var qrHelp = el('p', { 'class': 'tpxw-h' }, t.previewEmpty);
    qrTxt.appendChild(qrHelp);
    box.appendChild(qrHold); box.appendChild(qrTxt);
    root.appendChild(box);

    var msgs = el('div', { 'class': 'tpxw-m', 'aria-live': 'polite' });
    root.appendChild(msgs);
    var conf = check(P + '-ok', t.confirm, false);
    root.appendChild(conf.wrap);


    // Propiedades que viajan con la línea del carrito
    var props = {};
    function prop(name, value) {
      if (value == null || value === '') { delete props[name]; return; }
      props[name] = value;
    }
    var state = { res: null };
    function data() { return { ssid: ssid.value, password: pw.value, security: sec.value, hidden: hid.input.checked }; }

    function render(showErrors) {
      var d = data();
      pwF.style.display = d.security === 'NONE' ? 'none' : '';
      var r = W.build(d);
      state.res = r;
      msgs.innerHTML = '';
      var list = [];
      if (showErrors || ssid.value || pw.value) {
        r.errors.forEach(function (e) { if (e !== 'ssid_empty' || showErrors) list.push(['e', t['e_' + e] || e]); });
      }
      r.warnings.forEach(function (w) { if (t['w_' + w]) list.push(['w', t['w_' + w]]); });
      if (showErrors && !conf.input.checked) list.push(['e', t.e_confirm]);
      list.forEach(function (m) { msgs.appendChild(el('p', { 'class': m[0] === 'e' ? 'tpxw-err' : 'tpxw-warn' }, m[1])); });

      qrHold.innerHTML = '';
      if (r.ok && window.qrcode) {
        var q = window.qrcode(0, 'M');
        q.stringToBytes = window.qrcode.stringToBytesFuncs['UTF-8'];
        q.addData(r.payload, 'Byte');
        q.make();
        // margin va en píxeles: 16 px = 4 módulos de zona blanca, lo que pide el estándar
        qrHold.innerHTML = q.createSvgTag({ cellSize: 4, margin: 16, scalable: true });
        qrHelp.textContent = t.previewHelp;
        // Lo que lee el móvil, en claro, para comparar con el router
        var back = W.parse(r.payload) || {};
        var shown = el('p', { 'class': 'tpxw-h tpxw-read' });
        shown.appendChild(document.createTextNode(t.reads + ' '));
        shown.appendChild(el('code', null, back.S));
        if (back.P != null) { shown.appendChild(document.createTextNode(' · ' + t.pw + ': ')); shown.appendChild(el('code', null, back.P)); }
        qrHelp.appendChild(shown);
      } else {
        qrHelp.textContent = t.previewEmpty;
      }

      // Propiedades visibles (en el idioma del cliente) y canónicas (para la app)
      var secLabel = d.security === 'WPA' ? 'WPA/WPA2/WPA3' : d.security === 'WEP' ? 'WEP' : t.open;
      var lang = langSel.value;
      var plateText = PLATE[lang] + ' · ' + (creds.input.checked ? t.creds : t.nocreds);
      prop(t.p_ssid, d.ssid);
      prop(t.p_pw, d.security === 'NONE' ? '' : d.password);
      prop(t.p_sec, secLabel);
      prop(t.p_hidden, d.hidden ? t.yes : '');
      prop(t.p_plate, plateText);
      prop('_wifi_ssid', d.ssid);
      prop('_wifi_pw', d.security === 'NONE' ? '' : d.password);
      prop('_wifi_sec', d.security);
      prop('_wifi_hidden', d.hidden ? '1' : '');
      prop('_wifi_lang', lang);
      prop('_wifi_creds', creds.input.checked ? '1' : '0');
      prop('_wifi_qr', r.ok ? r.payload : '');
      prop('_wifi_v', '1');
      var ok = r.ok && conf.input.checked;
      if (opts.onChange) opts.onChange(ok);
      return ok;
    }

    [ssid, pw].forEach(function (i) { i.addEventListener('input', function () { render(false); }); });
    [sec, hid.input, langSel, creds.input, conf.input].forEach(function (i) { i.addEventListener('change', function () { render(false); }); });
    render(false);
    return {
      render: render,
      props: function () { var o = {}; for (var k in props) o[k] = props[k]; return o; },
      result: function () { return state.res; },
      t: t
    };
  }
  window.TapticsWifiForm = { create: create };

  // Ficha del producto Taptics WiFi
  var root = document.getElementById('tpx-wifi');
  if (!root) return;
  var form = null, inputs = {}, f = null;
  function sync() {
    if (!form || !f) return;
    var p = f.props(), key;
    for (key in inputs) if (!(key in p)) { inputs[key].remove(); delete inputs[key]; }
    for (key in p) {
      // getAttribute: form.id devolvería el <input name="id"> de la variante
      if (!inputs[key]) { inputs[key] = el('input', { type: 'hidden', name: 'properties[' + key + ']', form: form.getAttribute('id') }); root.appendChild(inputs[key]); }
      inputs[key].value = p[key];
    }
  }
  f = create(root, { lang: root.getAttribute('data-lang') || 'es', idp: 'tpxw', onChange: sync });
  function block(e) {
    if (f.render(true)) return;
    e.preventDefault(); e.stopImmediatePropagation();
    root.scrollIntoView({ behavior: 'smooth', block: 'center' });
    root.classList.add('tpxw-bad'); setTimeout(function () { root.classList.remove('tpxw-bad'); }, 2000);
  }
  function mount() {
    var info = document.querySelector('[id^="ProductInformation-"]') || document;
    var buttons = info.querySelector('.product-form-buttons');
    form = buttons && buttons.closest('form');
    if (!form) form = info.querySelector('form[data-type="add-to-cart-form"]');
    if (!form) return false;
    if (buttons) buttons.parentNode.insertBefore(root, buttons);
    root.style.display = '';
    // Intercepta el envío antes que el tema (fase de captura en document)
    document.addEventListener('submit', function (e) { if (e.target === form) block(e); }, true);
    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('button[name="add"], button[type="submit"]');
      if (b && (b.form === form || form.contains(b))) block(e);
    }, true);
    f.render(false);
    return true;
  }
  if (!mount()) document.addEventListener('DOMContentLoaded', mount);
})();
